import React, { FC } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

type Props = {
  show: boolean;
  onAction?: () => void;
};

export const PaymentFailedBanner: FC<Props> = ({ show, onAction }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 bg-danger-light border border-danger rounded-3 px-3 py-3 mb-4">
      <div className="d-flex align-items-start gap-2">
        <InfoCircle className="text-danger flex-shrink-0 fs-5 mt-1" />
        <div>
          <p className="fw-bold text-danger m-0 fs-6 fs-md-5">
            {t("payment.paymentFailedTitle")}
          </p>
          <p className="text-danger m-0 fs-7 fs-md-6">
            {t("payment.paymentFailedDescription")}
          </p>
        </div>
      </div>
      <button
        type="button"
        className="col-12 col-md-auto btn btn-danger text-white fw-bold text-nowrap fs-7 px-4 lh-sm rounded-3"
        onClick={onAction}
      >
        {t("payment.paymentFailedCta")}
      </button>
    </div>
  );
};
